<template>
  <div class="module-data-statistics-index">
    <el-row style="padding-bottom:10px">
      <el-col :span="19">&nbsp;</el-col>
      <el-col :span="5">
        <el-input
          class="search-input search-input--right"
          size="medium"
          placeholder="请输入模块名称"
          icon="el-icon-search"
          style="width: 100%"
          clearable
          v-model="form.modulueName"
          @change="handleModulueNameChange"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
          ></el-button>
        </el-input>
      </el-col>
    </el-row>

    <div class="tabeWrapper">
      <el-table
        stripe
        border
        fit
        highlight-current-row
        style="width: 100%"
        :height="windowHeight - 215"
        :data="dataList"
      >
        <el-table-column
          label="序号"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="模块名称"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{scope.row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="模块编码"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{scope.row.code}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="使用分类"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{scope.row.isIntegrate | filterIsIntegrate}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="适应平台"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{scope.row.systemType | filterSystemType}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="适应学段"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{scope.row.schoolType | filterSchoolType}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="安装学校数"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{scope.row.usedCount}}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="操作"
        >
          <template slot-scope="scope">
            <el-button
              size="small"
              type="text"
              @click="gotoDetail(scope.row)"
            >查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        style="margin-top: 20px"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="pagination.pageNo"
        :page-size="pagination.pageSize"
        :page-sizes="pagination.pageSizes"
        :total="pagination.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
/* utils */
import mixin from "@/mixins/windowResize";

/* components */

/* api */
import { listModuleInstallDetail } from "@/api/moduleDataStatistics";

export default {
  mixins: [mixin],
  components: {},
  filters: {
    filterIsIntegrate(val) {
      return val == 1 ? "系统应用" : "集成应用";
    },
    filterSystemType(val) {
      if (val == 1) {
        return "通用";
      } else if (val == 2) {
        return "微校+";
      } else {
        return "成长乐园";
      }
    },
    filterSchoolType(val) {
      if (val == 1) {
        return "幼儿园";
      } else if (val == 2) {
        return "中小学";
      } else {
        return "通用";
      }
    },
  },
  data() {
    return {
      // 是否正在加载数据 { Boolean }
      tabLoading: false,
      // 表格数据 { Array }
      dataList: [],
      // 分页
      pagination: {
        pageNo: 1,
        pageSize: 20,
        pageSizes: [10, 20, 30, 50],
        total: 0,
      },
      form: {
        modulueName: "",
      },
    };
  },
  created() {
    this.listModuleInstallDetail();
  },
  methods: {
    listModuleInstallDetail() {
      listModuleInstallDetail({
        modulueName: this.form.modulueName,
        pageNo: this.pagination.pageNo,
        pageSize: this.pagination.pageSize,
      }).then((data) => {
        let { dataList, pagination } = data;
        this.dataList = [...dataList];
        this.pagination.total = pagination.total;
      });
    },
    handleModulueNameChange() {
      this.pagination.pageNo = 1;
      this.listModuleInstallDetail();
    },
    // 分页 - pageSize 改变
    handleSizeChange(pageSize) {
      this.pagination.pageSize = pageSize;
      this.listModuleInstallDetail();
    },
    // 分页 - currentPage 改变
    handleCurrentChange(pageNo) {
      this.pagination.pageNo = pageNo;
      this.listModuleInstallDetail();
    },

    // 详情页
    gotoDetail(item) {
      console.log(item);
      this.$router.push({
        path: "detail",
        query: {
          moduleCode: item.code,
          moduleName: item.name,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.module-data-statistics-index {
  padding: 12px;
  * {
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dataStatistics/moduleDataStatistics/index.vue